export default [
  {
    path: "/raffle",
    component: () => import("@/views/raffle/index"),
    children: [
      {
        path: "wheel",
        component: () => import("@/views/raffle/wheel"),
        meta: {
          title: "大转盘"
        }
      },
      {
        path: "raffleRecord",
        component: () => import("@/views/raffle/raffleRecord"),
        meta: {
          title: "中奖记录"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/raffle.js